import { render, staticRenderFns } from "./AuthorBlock.vue?vue&type=template&id=2abb2ea6&"
import script from "./AuthorBlock.vue?vue&type=script&lang=js&"
export * from "./AuthorBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports